import React from 'react';
import PawIcon from '../PawIcon';

export const DogIcon: React.FC = () => (
  <span role="img" aria-label="dog" style={{ fontSize: '2rem' }}>🐶</span>
);

export const CatIcon: React.FC = () => (
  <span role="img" aria-label="cat" style={{ fontSize: '2rem' }}>😻</span>
);

export const BirdIcon: React.FC = () => (
  <span role="img" aria-label="bird" style={{ fontSize: '2rem' }}>🦜</span>
);

export const SmallAnimalIcon: React.FC = () => (
  <span role="img" aria-label="small animal" style={{ fontSize: '2rem' }}>🐹</span>
);

export const AllPetsIcon: React.FC = () => (
  <span role="img" aria-label="all pets" style={{ fontSize: '2rem' }}>🐾</span>
);

interface PetIconProps {
  type: string;
  size?: number;
}

const PetIcon: React.FC<PetIconProps> = ({ type, size = 32 }) => {
  const style = { fontSize: `${size}px` };
  switch (type) {
    case 'Dog':
      return <span role="img" aria-label="dog" style={style}>🐶</span>;
    case 'Cat':
      return <span role="img" aria-label="cat" style={style}>😻</span>;
    case 'Bird':
      return <span role="img" aria-label="bird" style={style}>🦜</span>;
    case 'Small Animal':
      return <span role="img" aria-label="small animal" style={style}>🐹</span>;
    case 'All':
      return <span role="img" aria-label="all pets" style={style}>🐾</span>;
    default:
      return <PawIcon width={size} height={size} color="var(--primary-700)" />;
  }
};

export default PetIcon;
